/* esm.sh - @scure/base@2.0.0 */
export * from "/*@scure/base@2.0.0/esnext/base.mjs";
